export function SortArrowDownSvg() {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="7"
         height="13"
         viewBox="6 0 7 13"
         fill="none"
      >
         <path
            d="M12.0998 2.53098L10.2063 0.65898C9.71933 0.17148 8.92633 0.17148 8.44183 0.65598L6.54533 2.53098C6.25083 2.82198 6.24833 3.29698 6.53933 3.59148C6.83033 3.88648 7.30583 3.88848 7.60033 3.59748L8.57283 2.63598V11.5425C8.57283 11.9565 8.90833 12.2925 9.32283 12.2925C9.73733 12.2925 10.0728 11.9565 10.0728 11.5425V2.63548L11.0453 3.59698C11.1913 3.74148 11.3823 3.81398 11.5728 3.81398C11.7663 3.81398 11.9593 3.73998 12.1063 3.59148C12.3973 3.29698 12.3943 2.82198 12.0998 2.53098Z"
            fill="white"
         />
      </svg>
   )
}
